import cx from "classnames";
import Image from "next/image";
import { ReactNode } from "react";

import { TextBlock } from "./TextBlock";

export enum ImgDirection {
  Right,
  Left,
}

type TextBlockWithImgProps = {
  title: ReactNode;
  description: ReactNode;
  imgSrc: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >["src"];
  imgDirection: ImgDirection;
  priority?: boolean;
};

export const TextBlockWithImg = ({
  title,
  description,
  imgSrc,
  imgDirection,
  priority = false,
}: TextBlockWithImgProps) => (
  <div
    className={cx(
      "flex flex-col gap-8 justify-between items-center w-full",
      imgDirection === ImgDirection.Right && "md:flex-row-reverse",
      imgDirection === ImgDirection.Left && "md:flex-row",
    )}
  >
    <div className="overflow-hidden relative order-2 w-full h-96 max-h-[323px] rounded-xl md:order-1 md:w-1/2">
      <Image
        layout="fill"
        objectFit="cover"
        src={imgSrc as string}
        alt="img"
        priority={priority}
      />
    </div>

    <div className="order-1 w-full md:order-2 md:w-1/2">
      <TextBlock title={title} description={description} />
    </div>
  </div>
);
